export default {
    home: {
        title: 'Sneller en leuker overhoren voor hogere cijfers',
        subtitle: 'Met dit overhoorprogramma leer je leuk en snel de theorie die je moet kennen. Met Ikleeralles.nl is overhoren niet meer saai!',
        login: 'Inloggen',
        register: 'Registreren',
    }
    // ... Add other Dutch translations
};